import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { message, Form } from "antd";
import 'babel-polyfill';

import "./login-admin.css";
import logo from '../../../imgs/login_logo.jpg';
import { accessUrlConfig as ccjeUrl } from "../../../config/accessUrlConfig.js";
import { util } from "../../../util/util.js";
import appConfig from './../../../config/appConfig';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginInfor: {
        username: "",
        password: ""
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.login = this.login.bind(this);
  }

  login(e) {
    // 调试时暂时使用
    // sessionStorage.setItem("isLogin",true);
    // sessionStorage.setItem("username","admin");
    // this.storageUserId("admin","admin");
    // return window.location.href = "../index.html";
    e.preventDefault();
    let _loginInfor = this.state.loginInfor;
    let _this = this;
    let _flag = true;
    for (var j in _loginInfor) {
      if (!_loginInfor[j]) {
        _flag = false;
        message.error('用户名或密码不能为空',5);
      }
    }
    fetch(appConfig.okapiHost, {
            method: 'POST',
            headers: { 'X-Okapi-Tenant': appConfig.XOkapiTenant, 'Content-type': "application/json" },
            body: JSON.stringify(_loginInfor),
          }).then((response) => {
            if (response.status >= 400) {
              message.error('登录失败,请检查用户名及密码',5);
            } else {
              response.json().then((data) => {
                const token = response.headers.get('X-Okapi-Token');
                sessionStorage.setItem("token", token);
                //判断管理员状态，停用的则不允许登录
                util.getData(ccjeUrl.accountAdmin.getEntityByLoginName + _loginInfor.username).then(
                  async (data_user) => {
                    if (_flag) {
                      let username = _loginInfor.username;
                      sessionStorage.setItem("username", username);
                      sessionStorage.setItem("userId", data.user.id);
                      sessionStorage.setItem("permissions", JSON.stringify(data.permissions));
                      sessionStorage.setItem("isLogin", true);
                      _this.storageUserId(username, "admin");
                    }
                  },
                  (data_user) => {
                    message.error("请求后台错误，错误代码:" + data_user.code + "，错误信息:" + data_user.errorMessage, 5);
                  }
                );
              });

            }
          });

  }

  storageUserId = (username, type) => {
    let _this = this;
    if (type === "admin") {
      util.getData(ccjeUrl.accountAdmin.getEntityByLoginName + username).then(
        async (data) => {
          sessionStorage.setItem("adminId", data.data.adminId);
          sessionStorage.setItem("okapiUserId", data.data.okapiUserId);
          //将用户所属单位，角色名称放入session，以备首页右上角使用--by guomh
          sessionStorage.setItem("userUnit", data.data.unit);
          sessionStorage.setItem("roleName", data.data.roleName);
          //将用户类型放入session，以备在index.js使用，指向不同用户类型的页面--by guomh
          sessionStorage.setItem('userType',data.data.userType);
          let _r = await _this.getMenuData(data.data.adminId);
          if (_r) window.location.href = "../index.html";
        },
        (data) => {
          message.error("请求后台错误，错误代码:" + data.code + "，错误信息:" + data.errorMessage, 5);
        }
      );
    } else {
      util.getData(ccjeUrl.accountExpert.getEntityByLoginName + username).then(
        async (data) => {
          sessionStorage.setItem("eId", data.data.eId);
          sessionStorage.setItem("okapiUserId", data.data.okapiUserId);
          sessionStorage.setItem("roleName", data.data.roleName);
          sessionStorage.setItem("userUnit", data.data.unit);
          let _r = await _this.getMenuData(data.data.adminId);
          if (_r) window.location.href = "../index.html";
        },
        (data) => {
          message.error("请求后台错误，错误代码:" + data.code + "，错误信息:" + data.errorMessage, 5);
        }
      );
    }
  }

  handleChange(e) {
    let _loginInfor = this.state.loginInfor;
    _loginInfor[e.target.name] = e.target.value;
    this.setState({
      loginInfor: _loginInfor
    });
  }

  componentWillMount() {
    let sessionIsLogin = !!(sessionStorage.getItem("isLogin") == "true");
    let isLogin = (sessionIsLogin == "" || sessionIsLogin == undefined || sessionIsLogin == null) ? false : sessionIsLogin;
    let _menu = sessionStorage.getItem("menu");
    if (isLogin && _menu) { //加入对菜单数据的判断
      window.location.href = "../index.html";
    }
  }

  render() {
    return (
      <div className="wrap" >
        <header>
          <h1>
            北京大学图书馆《中文核心期刊要目总览》审核
          </h1>
        </header>
        <Form className="main" onSubmit={this.login}>
          <div className="main-box" >
            <p className="login-title" >中文核心期刊评价系统</p>
            <div className="input-box" >
              <input name="username" value={this.state.loginInfor.username} onChange={this.handleChange} placeholder="请输入用户名" className="input user-name" />
              <input name="password" value={this.state.loginInfor.password} onChange={this.handleChange} type="password" placeholder="请输入密码" className="input user-password" />
               {/* <input name="user-check" placeholder="请输入验证码" className="input user-check" /> */}
              <button type="submit" className="btn"></button>
              <p className="right-text" ><a title="如您忘记密码请发邮件咨询（hxqk@lib.pku.edu.cn）" href="###" >忘记密码</a></p>
              <p className="right-text" ><a href="http://hxqk.lib.pku.edu.cn/sites/default/files/2023expertreviewprocess.pdf">专家评审流程说明</a></p>
            </div>
          </div>
        </Form>
        <footer>
          <p>北京大学图书馆&nbsp;&nbsp;&nbsp;CALIS管理中心&nbsp;&nbsp;&nbsp;版权所有</p>
        </footer>
      </div>
    );
  }

  /**
   * 从服务器获取菜单数据
   * @param {*string} adminID
   */
  getMenuData(adminID) {
    return util.getData(ccjeUrl.rightConfig.userTree + '?userid=' + adminID)
      .then(
      d => {
        sessionStorage.setItem("menu", JSON.stringify(d.data));
        return true;
      },
      d => {
        message.error("请求后台错误，错误代码:" + d.code + "，错误信息:" + d.errorMessage, 5);
        return false;
      }
      );
  }
}




ReactDOM.render(<Login />, document.getElementById("root"));



// WEBPACK FOOTER //
// src/pages/login/login-admin/login-admin.js